import { ChangeDetectorRef, Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, tap } from 'rxjs';
import { NotificationContactsService } from '../../services/notification-contacts/notification-contacts.service';
import { isArrayWithData } from '../../utilities/array.helpers';

@Component({
    selector: 'app-notification-contacts',
    templateUrl: './notification-contacts.component.html',
    styleUrl: './notification-contacts.component.css',
})
export class NotificationContactsComponent {
    isSideBarVisible: boolean = false;
    isDeleteModalVisible: boolean = false;
    toDeleteItem: any;
    editedId: number = 0;
    selectedCreditorId: string = '';
    creditorCompanyName: string = '';
    notificationContacts!: any[];

    firstName: string = '';
    lastName: string = '';
    email: string = '';
    creditors: any[] = [];
    hasClickedSearch: boolean = false;

    public constructor(
        private etlIngestionService: EtlIngestionService,
        private appService: AppService,
        private notificationContactService: NotificationContactsService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {}

    get hasTableData(): boolean {
        return isArrayWithData(this.notificationContacts);
    }

    onSelectCreditor(event: any) {
        this.hasClickedSearch = false;
        this.selectedCreditorId = event.CreditorId;
        this.creditorCompanyName = event.CompanyName;
    }

    search() {
        if (!!this.selectedCreditorId) {
            this.appService.isShowPageSpinner = true;
            this.notificationContactService
                .get(this.selectedCreditorId)
                .pipe(
                    tap((res: any) => {
                        if (!!res && Array.isArray(res) && res.length > 0) {
                            this.notificationContacts = res;
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                        this.hasClickedSearch = true;
                    }),
                )
                .subscribe();
        }
    }

    onOpenSideBar(
        id: number = 0,
        firstName: string = '',
        lastName: string = '',
        email: string = '',
    ) {
        if (!!this.selectedCreditorId) {
            this.editedId = id;
            this.firstName = firstName;
            this.lastName = lastName;
            this.email = email;
            this.isSideBarVisible = true;
        } else {
            this.appService.showSelectCreditorMessage();
        }
    }

    onOpenDeleteModal(item: any) {
        this.toDeleteItem = item;
        this.isDeleteModalVisible = true;
    }

    onConfirmDelete() {
        if (!!this.toDeleteItem) {
            this.appService.isShowPageSpinner = true;

            this.notificationContactService
                .delete(this.toDeleteItem)
                .pipe(
                    tap(() => {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Notification Contact has been successfully deleted.',
                        );
                        this.notificationContacts =
                            this.notificationContacts.filter(
                                (i: any) =>
                                    i.NotificationContactId !==
                                    this.toDeleteItem.NotificationContactId,
                            );
                        this.isDeleteModalVisible = false;
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    }),
                )
                .subscribe();
        }
    }

    onSave() {
        this.appService.isShowPageSpinner = true;
        if (!this.editedId && !!this.selectedCreditorId) {
            this.notificationContactService
                .post(
                    +this.selectedCreditorId,
                    this.firstName,
                    this.lastName,
                    this.email,
                )
                .pipe(
                    tap((res: any) => {
                        setTimeout(() => {
                            this.appService.showCommonMessageDialog(
                                'Success',
                                'Notification Contact has been successfully created.',
                            );
                            this.isSideBarVisible = false;
                            this.search();
                        }, 2000);
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {}),
                )
                .subscribe();
        } else {
            this.notificationContactService
                .put(
                    this.editedId,
                    +this.selectedCreditorId,
                    this.firstName,
                    this.lastName,
                    this.email,
                )
                .pipe(
                    tap(() => {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Notification Contact has been successfully updated.',
                        );
                        this.isSideBarVisible = false;

                        const newNotificationContacts =
                            this.notificationContacts.map((item: any) => {
                                if (
                                    item.NotificationContactId == this.editedId
                                ) {
                                    item.FirstName = this.firstName;
                                    item.LastName = this.lastName;
                                    item.Email = this.email;
                                }
                                return item;
                            });
                        this.notificationContacts = newNotificationContacts;
                        this.cdr.detectChanges();
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                    }),
                )
                .subscribe();
        }
    }
}
